import { RelativeBox, NacidTable, AlertSpg, OptionTableCell } from "@duosoftbg/nacid-components";
import { TableBody, TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import {
  changeOrderBy,
  changePage,
  changePageSize,
} from "../../../../../../store/redux/slice/Request/arUniEntryRequestFilter";
import ARUniEntryRequestStatusIcon from "./ARUniEntryRequestStatusIcon";

const ARUniEntryRequestListTable = ({
  createOptions = (record) => {
    return <></>;
  },
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const headCells = [
    {
      id: "requestStatus",
      label: "",
      sortable: true,
    },
    { id: "applicant", label: t("l.arUniEntryRequest.table.head.applicant"), sortable: true },
    {
      id: "university",
      label: t("l.table.head.foreignUniversity"),
      sortable: true,
    },
    {
      id: "diplomaSpeciality",
      label: "l.table.head.acquiredSpeciality",
      sortable: true,
    },
    {
      id: "educationLevel",
      label: "l.arUniEntryRequest.table.head.acquiredEduLevel",
      sortable: true,
    },
    {
      id: "recognizingUniversityName",
      label: "l.table.head.university",
      sortable: true,
    },
    {
      id: "recognizedSpeciality",
      label: "l.table.head.recognizedSpeciality",
      sortable: true,
    },
    {
      id: "recognizedEducationLevel",
      label: "l.arUniEntryRequest.table.head.recognizedEducationLevel",
      sortable: true,
    },
    {
      id: "protocolNumber",
      label: "l.arUniEntryRequest.table.head.protocolNumber",
      sortable: true,
    },
    {
      id: "recognitionStatus",
      label: "l.arUniEntryRequest.recognitionStatus",
      sortable: true,
    },
    { id: "options", label: "l.table.head.options", sortable: false },
  ];

  const arUniEntryRequestFilter = useAppSelector((state) => {
    return state.Request.arUniEntryRequestFilter;
  });

  const arUniEntryRequests = useAppSelector((state) => {
    return state.Request.arUniEntryRequests;
  });

  if (arUniEntryRequests.list.data.totalElements === 0) {
    return <AlertSpg severity={"info"}>{t("m.empty.list")}</AlertSpg>;
  }
  return (
    <RelativeBox>
      <NacidTable
        total={arUniEntryRequests.list.data.totalElements}
        page={arUniEntryRequestFilter.page}
        pageSize={arUniEntryRequestFilter.pageSize}
        orderBy={arUniEntryRequestFilter.orderBy}
        order={arUniEntryRequestFilter.order}
        onSortClick={(e, prop) => {
          dispatch(changeOrderBy(prop));
        }}
        headCells={headCells}
        onPageChange={(e, page) => {
          dispatch(changePage(page));
        }}
        onRowsPerPageChange={(e) => {
          dispatch(changePageSize(e.target.value));
        }}
      >
        <TableBody>
          {arUniEntryRequests.list.data.content.map((record) => (
            <TableRow key={record.id}>
              <TableCell>
                <ARUniEntryRequestStatusIcon status={record.requestStatus} />
              </TableCell>
              <TableCell>{record.applicant}</TableCell>
              <TableCell>{record.university}</TableCell>
              <TableCell>{record.diplomaSpeciality}</TableCell>
              <TableCell>{record.educationLevel}</TableCell>
              <TableCell>{record.recognizingUniversity.universityName}</TableCell>
              <TableCell>{record.recognizedSpeciality}</TableCell>
              <TableCell>{record.recognizedEducationLevel ? record.recognizedEducationLevel.name : "---"}</TableCell>
              <TableCell>{record.protocolNumber + "/" + record.protocolDate}</TableCell>
              <TableCell>{record.recognitionStatus.name}</TableCell>
              <OptionTableCell>{createOptions(record)}</OptionTableCell>
            </TableRow>
          ))}
        </TableBody>
      </NacidTable>
    </RelativeBox>
  );
};
export default ARUniEntryRequestListTable;
